import * as React from 'react';
import App, { AppContext } from '../App';
import {Component} from '@wordpress/element';
// @ts-ignore
import { CSVDownload } from 'react-csv';

// @ts-ignore
const { addQueryArgs, removeQueryArgs } = wp.url;
// @ts-ignore
const { decodeEntities } = wp.htmlEntities;
// @ts-ignore
const { apiFetch } = wp;

interface ExportProps {
    getQueryURL: () => string,
    terms: TaxonomiesList,
}

const PER_PAGE = 100;

// CSV file headers and map to the data object properties.
const CSV_HEADERS = [
    { label: "Title", key: "title" },
    { label: "ID", key: "id" },
    { label: "Publish Date", key: "date" },
    { label: "Modified Date", key: "modified" },
    { label: "Region", key: "region" },
    { label: "Sector", key: "sector" },
    { label: "Deal Type", key: "deal_type" },
    { label: "Deal Value", key: "deal_value" },
    { label: "Link", key: "link" },
];
const BASE_CLASS_NAME = 'pbc-facet-export';

// Taxonomies that need to be in the csv file.
const MAP_TAXONOMIES = [ 'region', 'sector', 'deal_type', 'deal_value' ];

export class Export extends Component<ExportProps> {
    state = {
        status: 'stopped', // stopped | started | finished | errored
        progress: 0,
        filename: '',
        // @ts-ignore
        data: [],
        error: '',
    }

    interval: number = null;

    exportDeals = async () => {
        // getQueryURL comes from the main App component state by using React Provider.
        const { getQueryURL, terms } = this.props;
        let exportUrl = addQueryArgs(
            getQueryURL(),
            { per_page: PER_PAGE }
        );

        // Exclude some data from the response that could slow things down.
        exportUrl = removeQueryArgs( exportUrl, [ '_embed' ] );

        this.setState( {
            status: 'starting',
            data: [],
            error: '',
        } );

        let finished = false;
        let totalPages = -1;
        let progress = 0;
        let currentPage = 0;

        while ( finished === false ) {
            const { data } = this.state;

            const page = currentPage + 1;
            const queryUrl = addQueryArgs( exportUrl, { page } );

            let body = [];

            try {
                const request = await apiFetch( { path: queryUrl, parse: false } );
                const code = request.status;
                body = await request.json();
                totalPages = parseInt( request.headers.get( 'X-WP-TotalPages' ), 10 );
            }
            catch ( error ) {
                const message = await error.json();
                this.setState( {
                    status: 'errored',
                    error: `Export error [${ message.code }] - ${ message.message }`,
                    data: [],
                } );
                return;
            }

            progress = totalPages !== 0 ? Math.floor( ( page * 100 ) / totalPages ) : 100;

            const lastPage = page >= totalPages;
            finished = lastPage === true;

            const parsedData = body.map( ( deal: wpPost ) => {
                const { title, id, date, modified, link } = deal;
                const { rendered } = title;

                /**
                 * Map taxonomies to include into the CSV and split terms by taxonomies...
                 *
                 * This way, the taxonomies list would end up like:
                 * { region: 'London,UK,Spain', sector: 'retail,banking' }
                 *
                 * Every taxonomy will be saved into the CSV as a column.
                 */
                const taxonomies = MAP_TAXONOMIES.reduce( ( taxonomiesAcc: TaxonomiesList, taxonomy: string) => {
                    if ( ! terms[ taxonomy ] ) {
                        return taxonomiesAcc;
                    }

                    // @ts-ignore
                    const dealTermIds = deal[ taxonomy ] || [];

                    // ...Then join the term names and separate them with comma.
                    taxonomiesAcc[ taxonomy ] = dealTermIds.map(
                        ( termId: number ) => {
                            const term = terms[ taxonomy ][ termId ];
                            if ( ! term ) {
                                return false;
                            }
                            return term.name;
                        } )
                        .filter( ( termName: string | false ) => termName !== false )
                        .join( ',' );

                    return taxonomiesAcc;
                }, {} );

                // Return a CSV record
                return {
                    id,
                    date,
                    modified,
                    title: decodeEntities( rendered ),
                    link,
                    ...taxonomies,
                }
            } );
            const newData = [].concat.apply( [], [ data, parsedData ] );

            currentPage++;
            this.setState( {
                status: lastPage ? 'finished' : 'processing',
                data: newData,
                progress: finished ? 0 : progress,
            } );

            if ( finished ) {
                const currDate = new Date();
                const filename = `export-${ currDate.getMonth() }-${ currDate.getDate() }-${ currDate.getHours() }-${ currDate.getSeconds() }.csv`
                this.setState( { filename } );
            }
        }
    }

    componentDidUpdate(prevProps: Readonly<ExportProps>, prevState: Readonly<{}>, snapshot?: any) {
        const { status } = this.state;
        if ( status === 'finished' ) {
            window.clearInterval( this.interval );
        }
    }

    renderContent = () => {
        const { data, progress, status, filename, error } = this.state;
        const { terms } = this.props;
        const progressStyle = {
            width: `${progress}%`,
        }

        return <div className={ BASE_CLASS_NAME }>
            {
                status === 'errored' && <div className={ `${ BASE_CLASS_NAME }__error` }>
                    { error }
                </div>
            }
            {
                ( status === 'stopped' || status === 'finished' ) && <div>
                    <button onClick={ this.exportDeals }>Export results</button>
                </div>
            }
            {
                ( status === 'starting' || status === 'processing' ) && <div
			        className={ `${ BASE_CLASS_NAME }__status` }
		        >
                    {status === 'starting' && <h3>Initializing...</h3>}
                    {status === 'processing' && <h3>Preparing file...</h3>}
                    <div className={ `${ BASE_CLASS_NAME }__progressbar` }>
                      <div className="progressbar-percentage" style={ progressStyle } />
                      <div className="progressbar-label">{ progress }%</div>
                    </div>
		        </div>
            }
            {
                status === 'finished' && <div className={ `${ BASE_CLASS_NAME }__file-link` }>
                    <CSVDownload data={ data } headers={ CSV_HEADERS } filename={ filename } />
                </div>
            }
        </div>

    }
   render() {
       return (
           <AppContext.Consumer>
               {this.renderContent}
           </AppContext.Consumer>
       )
   }
}
